var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{on:{"click":function($event){return _vm.$emit('select-cur',_vm.currency.cc)}}},[_vm._v(_vm._s(_vm.currency.txt))])}
var staticRenderFns = []

export { render, staticRenderFns }